import _ from 'underscore';
import { get } from '@bingads-webui-universal/primitive-utilities';


const enums = {
  AdGroupCriterionStatus: {
    Active: 161,
    Paused: 162,
    Deleted: 163,
    Excluded: 165,
  },
  AdGroupCallTrackingStatus: {
    NotApplicable: 0,
    Eligible: 1,
    NotEligible: 2,
    ProvisioningPending: 3,
    Provisioned: 4,
  },
  AdGroupStatus: {
    CampaignUserPaused: 124,
    CampaignBudgetPaused: 126,
    CampaignBudgetUserPaused: 127,
    Draft: 140,
    Active: 141,
    Deleted: 143,
    Paused: 144,
    Expired: 150,
  },
  AdStatus: {
    Inactive: 0,
    Active: 1,
    Paused: 2,
    Deleted: 3,
  },
  AdType: {
    Text: 1,
    Product: 128,
    AppInstall: 256,
    DynamicSearch: 512,
    ExpandedText: 1024,
    Hotel: 2048,
    Responsive: 4096,
    ResponsiveSearch: 8192,
  },
  AdStrength: {
    Unrated: 0,
    Poor: 1,
    Average: 2,
    Good: 3,
    Excellent: 4,
  },
  BidTargetType: {
    Keyword: 0,
    BehaviorSegment: 11,
    Site: 12,
  },
  BidType: {
    BidOnly: 0,
    TargetAndBid: 1,
  },
  CallTrackingStatus: {
    NotApplicable: 0,
    Eligible: 1,
    NotEligible: 2,
    ProvisioningPending: 3,
    Provisioned: 4,
  },
  CampaignStatus: {
    Suspended: 8,
    Active: 121,
    Deleted: 123,
    UserPaused: 124,
    BudgetPaused: 126,
    BudgetUserPaused: 127,
  },
  DevicePreference: {
    All: 0,
    Mobile: 2,
  },
  CampaignType: {
    Default: 1,
    Shopping: 2,
    DynamicSearchAds: 4,
    Audience: 8,
    Smart: 16,
    Hotel: 32,
    PerformanceMax: 64,
  },
  DeliveryStatus: {
    CreditCardExpired: 10,
    IOExceeded: 20,
    PaymentInformationMissing: 30,
    InvalidFinancialStatusOther: 40,
    MigrationPaused: 45,
    CampaignDeleted: 48,
    CampaignSuspended: 49,
    CampaignBudgetPaused: 50,
    AdGroupExpired: 60,
    AdGroupDraft: 62,
    AdGroupDeleted: 63,
    CamAssetRejected: 64,
    CamAssetDeleted: 66,
    AdGroupTargetingTooNarrow: 67,
    EditorialRejected: 70,
    EditorialAppealRejected: 71,
    EditorialApprovedLimitedAppealRejected: 72,
    EditorialUnderAppeal: 75,
    UrlInvalid: 76,
    ApplicationNotFound: 77,
    ApplicationDestinationUrlMismatch: 78,
    PendingMetadataSync: 79,
    EditorialPending: 80,
    AssociationDeleted: 85,
    CampaignUserPaused: 90,
    AdGroupPrivacyPending: 91,
    AdGroupUserPaused: 100,
    AdUserPaused: 110,
    KeywordMatchTypeAdGroupMediumCombinationInvalid: 115,
    KeywordUserPaused: 120,
    NegativeKeywordConflicts: 130,
    PartialNegativeKeywordConflicts: 135,
    EditorialApprovedLimited: 200,
    LowSupply: 300,
    LowQuality: 400,
    BidBelowFirstPageBid: 500,
    Incomplete: 1000,
    BudgetSuggestions: 1001,
    InlineOpportunity: 1060,
    GeoCodingIncomplete: 1101,
    ProductTargetUserPaused: 1102,
    AdExtensionNotPresent: 1103,
    AdExtensionDeleted: 1104,
    AdExtensionAssociationDeleted: 1105,
    StoreIdNotAssociated: 1106,
    AdGroupAudienceAssociationPaused: 1107,
    AdGroupAudienceAssociationExcluded: 1108,
    AdNotPresent: 1200,
    AdNotActive: 1201,
    ApplicationDestinationUrlValidationIncomplete: 1252,
    AutoBiddingLimitedInventoryLimit: 1412,
    AutoBiddingLimitedMaxCPCRestriction: 1413,
    AutoBiddingLimitedBudgetRestriction: 1414,
    AutoBiddingLimitedUnAttainableTarget: 1415,
    AutoBiddingPortfolioBidStrategyTrainingStatus: 1421,
    Eligible: 2147483647,
    New: 2000,
    AutoBiddingLimitedByNotEnoughConversions: 190,
    NoEligibleAds: 105,
    NoEligibleKeywords: 106,
    NoEligibleAdGroups: 107,
  },
  BiddingStrategyType: {
    InheritFromParent: 0,
    ManualCpc: 1,
    MaxClicks: 2,
    MaxConversions: 3,
    TargetCpa: 4,
    EnhancedCpc: 5,
    TargetRoas: 6,
    MaxRoas: 7,
    MaxConversionValue: 8,
    TargetImpressionShare: 9,
    ManualCpv: 11,
    ManualCpm: 12,
    PercentCpc: 13,
    Commission: 14,
    CostPerSale: 15,
  },
  Language: {
    Arabic: 7,
    TraditionalChinese: 24,
    Danish: 28,
    Dutch: 29,
    English: 30,
    Finnish: 35,
    French: 36,
    German: 40,
    Italian: 55,
    Norwegian: 82,
    Portuguese: 88,
    Spanish: 109,
    Swedish: 112,
    SimplifiedChinese: 137,
    Greek: 41,
    Polish: 87,
    Czech: 27,
    Estonian: 32,
    Croatian: 26,
    Hungarian: 48,
    Lithuanian: 70,
    Latvian: 68,
    Maltese: 75,
    Romanian: 92,
    Slovak: 106,
    Slovenian: 107,
    Turkish: 123,
    Serbian: 98,
    Bosnian: 138,
    Albanian: 5,
    Macedonian: 71,
    Icelandic: 49,
    Japanese: 56,
    All: 1000,
  },
  Medium: {
    Search: 1,
    Content: 2,
    SearchAndContent: 3,
    Audience: 11,
  },
  OrderItemStatus: {
    Active: 161,
    Paused: 162,
    Deleted: 163,
  },
  MatchType: {
    Exact: 1,
    Phrase: 2,
    Broad: 3,
  },
};

const stringEnums = {
  AudienceType: {
    Remessaging: 'Remessaging',
    Custom: 'Custom',
    InMarket: 'InMarket',
    Product: 'Product',
    RemarketingSimilar: 'RemarketingSimilar',
    CustomerList: 'CustomerList',
    CombinedList: 'CombinedList',
  },
  Status: {
    Active: 'Active',
    Excluded: 'Excluded',
  },
  CriterionAgeCriterionAgeRange: {
    EighteenToTwentyFive: 'EighteenToTwentyFive',
    TwentyFiveToThirtyFive: 'TwentyFiveToThirtyFive',
    ThirtyFiveToFifty: 'ThirtyFiveToFifty',
    FiftyToSixtyFive: 'FiftyToSixtyFive',
    SixtyFiveAndAbove: 'SixtyFiveAndAbove',
    Unknown: 'Unknown',
  },
  CriterionGenderCriterionGenderType: {
    Male: 'Male',
    Female: 'Female',
    Unknown: 'Unknown',
  },
  AudienceCriterionLevel: {
    AdGroup: 'AdGroup',
    Campaign: 'Campaign',
  },
  AccountType: {
    AdAccount: 'AdAccount',
    ManagerAccount: 'ManagerAccount',
    Unknown: 'Unknown',
  },
};

const isFormat = fullValue => (/^Enum\.(\w+)'(\w+)'$/).test(fullValue);

export function fromLegacy(legacyValue, type) {
  if (isFormat(legacyValue)) {
    return legacyValue;
  }
  const value = _.findKey(enums[type], val => String(val) === legacyValue);

  return value ? `Enum.${type}'${value}'` : null;
}

export function toLegacy(fullValue) {
  if (!fullValue) {
    return fullValue;
  }
  const [, type, value] = fullValue.match(/^Enum\.(\w+)'(\w+)'$/);
  const legacyValue = get(enums, [type, value]);

  return _.isNumber(legacyValue) ? String(legacyValue) : get(stringEnums, [type, value]);
}

export function toLegacyString(fullValue) {
  if (!fullValue) {
    return fullValue;
  }
  const [, , value] = fullValue.match(/^Enum\.(\w+)'(\w+)'$/);

  return value;
}
